import * as _ from "lodash";
import { fetchHil, fetchHil2 } from "../utils";

export default {
  namespaced: true,
  state: {
    users: [],
    contracts: [],
    reports: [],
    billings: [],
    billingCount: 0,
    outstanding: [],
    nonZeroOutstanding: [],
    inactive: []
  },
  mutations: {
    setUsers(state, users) {
      for (const user of users) {
        if (!user.rewards) {
          user.rewards = {};
        }
        if (!user.rewards.sentToAL) {
          user.rewards.sentToAL = {};
        }
        if (!user.rewards.paid) {
          user.rewards.paid = {};
        }
      }
      state.users = users;
    },

    setContracts(state, contracts) {
      state.contracts = contracts;
    },

    setReports(state, reports) {
      state.reports = reports;
    },

    setBillingList(state, list) {
      state.billings = list;
    },

    setBillingCount(state, count) {
      state.billingCount = count;
    },

    setOutstandingBilling(state, outstanding) {
      state.outstanding = outstanding;
      state.nonZeroOutstanding = outstanding.filter(o => o.total > 0);
    },

    setInactiveTrigrams(state, inactive) {
      state.inactive = inactive;
    }
  },
  actions: {
    fetchUsers: _.debounce(async function({ commit }, { roles, search }) {
      const resp = await fetchHil(`/users`, {
        method: "POST",
        body: _.pickBy({ roles, search }, v => v !== undefined && v !== "")
      });
      commit("setUsers", await resp.json());
    }, 1e3),

    async fetchContracts({ commit }) {
      const resp = await fetchHil(`/contracts`);
      commit("setContracts", await resp.json());
    },

    async fetchReports({ commit }) {
      const resp = await fetchHil(`/cache/for/__reports`);
      commit("setReports", await resp.json());
    },

    async fetchBillingList(
      { commit },
      { skipZero, from, to, page, pageSize, sortBy, sortDirection, filter, id }
    ) {
      let url = `/billing?skipZero=${skipZero}&from=${from}&to=${to}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
      if (filter) {
        url += `&filter=${encodeURIComponent(filter)}`;
      }
      if (id) {
        url += `&id=${encodeURIComponent(id)}`;
      }
      const list = await fetchHil2("GET", url);
      commit("setBillingList", list.billings);
      commit("setBillingCount", list.total);
    },

    async fetchOutstandingBillingList({ commit }) {
      let url = `/billing/outstanding`;
      const outstanding = await fetchHil2("GET", url);
      commit("setOutstandingBilling", outstanding);
    },

    async confirmBilling(_, id) {
      return fetchHil2("POST", `/billing/${id}/confirm`);
    },

    async fetchInactiveTrigrams({ commit }) {
      const inactive = await fetchHil2("GET", "/user/inactiveStaff");
      commit("setInactiveTrigrams", inactive);
    }
  }
};
